import {Aggregators} from "./types";


export function calculateAggregationValues(aggregators:Aggregators, items:any[]):any {



    _.forEach(items, (item)=>{
        _.forEach(aggregators, (aggregator)=>{
            aggregator.processItem(item)
        })

    })


}